export default __webpack_public_path__ + "static/media/DissectIt_Step1.56610cdc.png";